import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import Button from '../UI/button';
import Select from '../UI/select';

//#region Styled Components
const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
`;

const StyledSelect = styled(Select)`
  margin-right: 0.75rem;
  width: 12rem;
`;
//#endregion

const ChooseList = ({ allLists, selectedList, setSelectedList }) => {
  let history = useHistory();

  const selectOptions = allLists.map(option => {
    return (
      <option key={option.id} value={option.id}>
        {option.name}
      </option>
    );
  });

  const viewList = () => {
    history.push(`/view/${selectedList}`);
  };

  return (
    <Container>
      <StyledSelect
        tabIndex="5"
        onChange={e => setSelectedList(e.target.value)}
        value={selectedList}
      >
        <option key="no-list-selected" value="no-list-selected">
          {allLists.length > 0 ? 'Select a List' : '-- No Lists --'}
        </option>
        {allLists && selectOptions}
      </StyledSelect>
      <Button onClick={viewList} disabled={!allLists.length}>
        View List
      </Button>
    </Container>
  );
};

export default ChooseList;
